import React from 'react'
import { Button } from 'primereact/button'

/**
 * Reusable template for displaying a field with a copy button
 * @param {Object} rowData - The row data object
 * @param {string} field - The field name to display and copy
 * @param {string} id - Optional ID for the container div
 * @returns JSX element with field value and copy button
 */
export const CopyFieldTemplate = (rowData, field, id) => {
    return (
        <div id={id} className="d-flex justify-content-start align-items-center flex-grow-1">
            {rowData[field]}
            {rowData[field] && (
                <div className="d-flex ml-auto">
                    <Button
                        icon="pi pi-copy"
                        className="white ml-2"
                        rounded
                        onClick={() => navigator.clipboard.writeText(rowData[field])}
                    />
                </div>
            )}
        </div>
    )
}
